<template>
  <div id="point-cloud" style="height: 60%;">
    <canvas
      id="c"
      class="pc"
      style="height: 60%;"
    ></canvas>
  </div>
</template>

<script>
import * as THREE from "three"
export default {
  name: "point-cloud",
  data() {
    return {
      renderer: null,
    }
  },
  destroyed() {
    
    console.log(`destroyes`)
    this.renderer.domElement.parentElement.removeChild(this.renderer.domElement)
    this.renderer.setAnimationLoop(null)

    window.onresize = null
    document.onmousemove = null
    document.onpointerdown = null
    document.onpointermove = null
  },
  mounted() {
    var scene, camera, renderer
    
    // I guess we need this stuff too
    var container,
      HEIGHT,
      WIDTH,
      fieldOfView,
      aspectRatio,
      nearPlane,
      farPlane,
      stats,
      geometry,
      particleCount,
      i,
      h,
      color,
      size,
      materials = [],
      mouseX = 0,
      mouseY = 0,
      windowHalfX,
      windowHalfY,
      cameraZ,
      fogHex,
      fogDensity,
      parameters = {},
      parameterCount,
      particles

    const localScope = this

    function init() {
      HEIGHT = window.innerHeight
      WIDTH = window.innerWidth
      windowHalfX = WIDTH / 2
      windowHalfY = HEIGHT / 2

      fieldOfView = 75
      aspectRatio = WIDTH / HEIGHT
      nearPlane = 1
      farPlane = 3000

      fogHex = 0x000000 /* As black as your heart.	*/
      fogDensity = 0.0007 /* So not terribly dense?	*/

      camera = new THREE.PerspectiveCamera(
        fieldOfView,
        aspectRatio,
        nearPlane,
        farPlane
      )
      camera.position.z = 10

      scene = new THREE.Scene()
      scene.fog = new THREE.FogExp2(fogHex, fogDensity)

      container = document.createElement("div")
      document.body.appendChild(container)
      document.body.style.margin = 0
      document.body.style.overflow = "hidden"

      geometry =
        new THREE.BufferGeometry() /*	NO ONE SAID ANYTHING ABOUT MATH! UGH!	*/

      const vertices = []

      particleCount = 20000 /* Leagues under the sea */

      for (i = 0; i < particleCount; i++) {
        var vertex = new THREE.Vector3()
        const [x, y, z] = [
          ...[
            Math.random() * 2000 - 1000,
            Math.random() * 2000 - 1000,
            Math.random() * 2000 - 1000,
          ],
        ]
        vertex.x = x
        vertex.y = y
        vertex.z = z

        vertices.push(x, y, z)
        // geometry.vertices.push(vertex)
      }
      geometry.setAttribute(
        "position",
        new THREE.Float32BufferAttribute(vertices, 3)
      )

      /*	We can't stop here, this is bat country!	*/

      parameters = [
        [[1, 1, 0.5], 5],
        [[0.95, 1, 0.5], 4],
        [[0.9, 1, 0.5], 3],
        [[0.85, 1, 0.5], 2],
        [[0.8, 1, 0.5], 1],
      ]
      parameterCount = parameters.length

      for (i = 0; i < parameterCount; i++) {
        color = parameters[i][0]
        size = parameters[i][1]

        materials[i] = new THREE.PointCloudMaterial({
          size: size,
        })

        particles = new THREE.PointCloud(geometry, materials[i])

        particles.rotation.x = Math.random() * 6
        particles.rotation.y = Math.random() * 6
        particles.rotation.z = Math.random() * 6

        scene.add(particles)
      }

      const canvas = document.querySelector("#c")


      renderer = new THREE.WebGLRenderer({
        canvas,
      })
      renderer.setPixelRatio(window.devicePixelRatio)
      renderer.setSize(WIDTH, HEIGHT)

      container.appendChild(renderer.domElement)

      localScope.renderer = renderer

      window.onresize = onWindowResize
      document.onmousemove = onDocumentMouseMove
      document.onpointerdown = onDocumentTouchStart // document.addEventListener("touchstart", onDocumentTouchStart, false)
      document.onpointermove = onDocumentTouchMove // document.addEventListener("touchmove", onDocumentTouchMove, false)
    }

    function animate() {
      requestAnimationFrame(animate)
      render()
    }

    function render() {
      var time = Date.now() * 0.00005

      camera.position.x += (mouseX - camera.position.x) * 0.05
      camera.position.y += (-mouseY - camera.position.y) * 0.05

      camera.lookAt(scene.position)

      for (i = 0; i < scene.children.length; i++) {
        var object = scene.children[i]

        if (object.type == "Points") {
          object.rotation.y = time * (i < 4 ? i + 1 : -(i + 1))
        }
      }

      for (i = 0; i < materials.length; i++) {
        color = parameters[i][0]

        h = ((360 * (color[0] + time)) % 360) / 360
        materials[i].color.setHSL(h, color[1], color[2])
      }

      renderer.render(scene, camera)
    }

    function onDocumentMouseMove(e) {
      mouseX = e.clientX - windowHalfX
      mouseY = e.clientY - windowHalfY
    }

    /*	Mobile users?  I got your back homey	*/

    function onDocumentTouchStart(e) {
      if (e.touches && e.touches.length === 1) {
        e.preventDefault()
        mouseX = e.touches[0].pageX - windowHalfX
        mouseY = e.touches[0].pageY - windowHalfY
      }
    }

    function onDocumentTouchMove(e) {
      if (e.touches && e.touches.length === 1) {
        e.preventDefault()
        mouseX = e.touches[0].pageX - windowHalfX
        mouseY = e.touches[0].pageY - windowHalfY
      }
    }

    function onWindowResize() {
      windowHalfX = window.innerWidth / 2
      windowHalfY = window.innerHeight / 2

      camera.aspect = window.innerWidth / window.innerHeight
      camera.updateProjectionMatrix()
      renderer.setSize(window.innerWidth, window.innerHeight)
    }

    init()
    animate()
  },
}
</script>